import React from 'react';
import { Button } from './components/Button';
import { PurchasePopup } from './components/PurchasePopup';
import { CountdownTimer } from './components/CountdownTimer';
import { BookOpen, Headphones, GraduationCap, Gift, CheckCircle2, Infinity, Star, ChevronDown, ShieldCheck, Clock, Zap } from 'lucide-react';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-inter selection:bg-gold selection:text-black pb-20" data-id="element-0">
      <PurchasePopup data-id="element-1" />

      {/* TOP BANNER */}
      <div className="bg-gold-gradient text-black text-center py-2 px-4 font-bold text-sm sm:text-base uppercase tracking-wider" data-id="element-2">
        ⚠️ ATENCIÓN: OFERTA ESPECIAL DISPONIBLE SOLO POR HOY
      </div>

      {/* HERO SECTION */}
      <section className="pt-12 pb-16 px-4 max-w-5xl mx-auto text-center" data-id="element-3">
        <div className="inline-block border border-gold/50 rounded-full px-4 py-1.5 mb-6 bg-gold/10 text-gold font-semibold text-sm sm:text-base animate-pulse" data-id="element-4">
          ⚡ ACCESO INMEDIATO Y PARA TODA LA VIDA
        </div>

        <h1 className="font-oswald text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold mb-8 text-white leading-tight uppercase tracking-tight" data-id="element-5">
          LA BIBLIOTECA <br className="hidden sm:block" data-id="element-6" />
          <span className="text-gold-gradient" data-id="element-7">DEL ÉXITO™</span>
        </h1>

        <div className="relative max-w-4xl mx-auto mb-8 group" data-id="element-8">
          <div className="absolute -inset-1 bg-gold rounded-xl blur opacity-20 group-hover:opacity-40 transition duration-1000" data-id="element-9"></div>
          <a href="https://colorpack.store/cart/45917604184262:1" className="block relative" data-id="element-10">
            <img src="https://cdn.magicpatterns.com/uploads/uMxsYpgg81XrJuVX1LdJWF/BIBLIOTECA.png" alt="La Biblioteca del Éxito Bundle" className="w-full h-auto rounded-xl shadow-2xl border border-gold/20" data-id="element-11" />
          </a>
        </div>

        <p className="text-xl sm:text-2xl md:text-3xl text-gray-300 mb-10 max-w-3xl mx-auto font-medium" data-id="element-12">
          La colección definitiva para transformar tu mente, tus finanzas y tu
          futuro.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto mb-10" data-id="element-13">
          {[{
          icon: BookOpen,
          text: '30.000 Libros'
        }, {
          icon: Headphones,
          text: '1.500 Audiolibros'
        }, {
          icon: GraduationCap,
          text: '100 Cursos'
        }, {
          icon: Gift,
          text: '5 Bonos Exclusivos'
        }].map((stat, i) => <div key={i} className="bg-[#111] border border-gold/20 rounded-lg p-4 flex flex-col items-center justify-center gap-2 hover:border-gold/50 transition-colors" data-id="element-14">
              <stat.icon className="w-8 h-8 text-gold" data-id="element-15" />
              <span className="font-bold text-sm sm:text-base" data-id="element-16">
                {stat.text}
              </span>
            </div>)}
        </div>

        <p className="text-lg sm:text-xl text-gray-400 mb-8 font-medium" data-id="element-17">
          Todo en un solo lugar y con acceso de por vida.
        </p>

        <Button subtext="Pago único. Acceso inmediato. Sin mensualidades." data-id="element-18">
          🚀 QUIERO TRANSFORMAR MI VIDA HOY
        </Button>
      </section>

      {/* STORY / PROBLEM SECTION */}
      <section className="py-16 px-4 bg-[#111] border-y border-gold/10" data-id="element-19">
        <div className="max-w-3xl mx-auto" data-id="element-20">
          <div className="space-y-6 text-lg sm:text-xl text-gray-300 leading-relaxed" data-id="element-21">
            <p className="font-bold text-2xl sm:text-3xl text-white text-center mb-8 font-oswald" data-id="element-22">
              La diferencia entre la persona que eres hoy y la persona que
              quieres ser...
            </p>
            <p className="text-center text-gold font-bold text-xl sm:text-2xl" data-id="element-23">
              Está en lo que aprendes cada día.
            </p>
            <p data-id="element-24">Cada libro que lees te acerca a una mejor versión de ti.</p>
            <p data-id="element-25">
              Cada idea nueva puede abrir una puerta que hoy ni siquiera sabes
              que existe.
            </p>

            <div className="bg-red-900/20 border border-red-500/30 rounded-lg p-6 my-8" data-id="element-26">
              <p className="font-bold text-white mb-4" data-id="element-27">
                El problema es que la mayoría de personas no tiene acceso al
                conocimiento correcto.
              </p>
              <ul className="space-y-3" data-id="element-28">
                <li className="flex items-start gap-3" data-id="element-29">
                  <span className="text-red-500 mt-1" data-id="element-30">❌</span>
                  <span data-id="element-31">Gastan cientos de dólares en libros.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-32">
                  <span className="text-red-500 mt-1" data-id="element-33">❌</span>
                  <span data-id="element-34">Pierden horas buscando contenido disperso.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-35">
                  <span className="text-red-500 mt-1" data-id="element-36">❌</span>
                  <span data-id="element-37">
                    Y nunca encuentran un sistema completo para crecer.
                  </span>
                </li>
              </ul>
            </div>

            <p className="text-center font-bold text-2xl mt-12 mb-8" data-id="element-38">
              Por eso creamos...
            </p>
            <h2 className="font-oswald text-4xl sm:text-5xl font-bold text-center text-gold-gradient mb-8" data-id="element-39">
              LA BIBLIOTECA DEL ÉXITO™
            </h2>
            <p className="text-center font-bold text-xl text-white mb-8" data-id="element-40">
              Todo lo que necesitas para aprender, crecer y avanzar
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto mb-8" data-id="element-41">
              {['Desarrollo personal', 'Finanzas personales', 'Negocios', 'Emprendimiento', 'Marketing digital', 'Ventas', 'Productividad', 'Liderazgo', 'Psicología', 'Mentalidad', 'Relaciones', 'Espiritualidad'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-[#0a0a0a] p-3 rounded-lg border border-gold/10" data-id="element-42">
                  <CheckCircle2 className="w-5 h-5 text-gold flex-shrink-0" data-id="element-43" />
                  <span className="font-medium" data-id="element-44">{item}</span>
                </div>)}
            </div>

            <p className="text-center font-bold text-xl text-gold mb-12" data-id="element-45">
              Y mucho más.
            </p>

            <Button data-id="element-46">📚 QUIERO ACCEDER A MI BIBLIOTECA DEL ÉXITO</Button>
          </div>
        </div>
      </section>

      {/* WHAT'S INCLUDED SECTION */}
      <section className="py-16 px-4 max-w-5xl mx-auto" data-id="element-47">
        <h2 className="font-oswald text-4xl sm:text-5xl font-bold text-center mb-12 uppercase" data-id="element-48">
          ¿Qué <span className="text-gold" data-id="element-49">incluye?</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-50">
          <div className="bg-[#111] p-8 rounded-xl border border-gold/20 hover:border-gold/50 transition-colors" data-id="element-51">
            <BookOpen className="w-12 h-12 text-gold mb-4" data-id="element-52" />
            <h3 className="font-oswald text-2xl font-bold mb-3" data-id="element-53">
              📚 30.000 Libros Digitales
            </h3>
            <p className="text-gray-400" data-id="element-54">
              Los libros más buscados sobre éxito, dinero, hábitos, liderazgo,
              productividad y crecimiento personal.
            </p>
          </div>

          <div className="bg-[#111] p-8 rounded-xl border border-gold/20 hover:border-gold/50 transition-colors" data-id="element-55">
            <Headphones className="w-12 h-12 text-gold mb-4" data-id="element-56" />
            <h3 className="font-oswald text-2xl font-bold mb-3" data-id="element-57">
              🎧 1.500 Audiolibros Premium
            </h3>
            <p className="text-gray-400" data-id="element-58">
              Aprende mientras conduces, caminas, entrenas o trabajas.
            </p>
          </div>

          <div className="bg-[#111] p-8 rounded-xl border border-gold/20 hover:border-gold/50 transition-colors" data-id="element-59">
            <GraduationCap className="w-12 h-12 text-gold mb-4" data-id="element-60" />
            <h3 className="font-oswald text-2xl font-bold mb-3" data-id="element-61">
              🎓 100 Cursos Digitales
            </h3>
            <p className="text-gray-400" data-id="element-62">
              Capacitación práctica para desarrollar habilidades de alto valor.
            </p>
          </div>

          <div className="bg-[#111] p-8 rounded-xl border border-gold/20 hover:border-gold/50 transition-colors" data-id="element-63">
            <Infinity className="w-12 h-12 text-gold mb-4" data-id="element-64" />
            <h3 className="font-oswald text-2xl font-bold mb-3" data-id="element-65">
              ♾️ Acceso para Toda la Vida
            </h3>
            <ul className="text-gray-400 space-y-2" data-id="element-66">
              <li className="flex items-center gap-2" data-id="element-67">
                <CheckCircle2 className="w-4 h-4 text-gold" data-id="element-68" /> Una sola
                inversión.
              </li>
              <li className="flex items-center gap-2" data-id="element-69">
                <CheckCircle2 className="w-4 h-4 text-gold" data-id="element-70" /> Sin
                mensualidades.
              </li>
              <li className="flex items-center gap-2" data-id="element-71">
                <CheckCircle2 className="w-4 h-4 text-gold" data-id="element-72" /> Sin renovaciones.
              </li>
              <li className="flex items-center gap-2" data-id="element-73">
                <CheckCircle2 className="w-4 h-4 text-gold" data-id="element-74" /> Sin cargos
                ocultos.
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-gradient-to-b from-[#111] to-[#0a0a0a] border border-gold/20 rounded-2xl p-8 max-w-3xl mx-auto mb-12" data-id="element-75">
          <h3 className="font-oswald text-3xl font-bold text-center mb-8" data-id="element-76">
            Autores y referentes incluidos
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-center" data-id="element-77">
            {['Robert Kiyosaki', 'Brian Tracy', 'Tony Robbins', 'Napoleon Hill', 'James Clear', 'Dale Carnegie', 'Robin Sharma', 'Stephen Covey', 'Deepak Chopra'].map((author, i) => <div key={i} className="bg-black/50 py-2 px-3 rounded border border-white/5 text-sm sm:text-base font-medium text-gray-300" data-id="element-78">
                📖 {author}
              </div>)}
          </div>
          <p className="text-center text-gold font-bold mt-6 text-xl" data-id="element-79">
            Y miles de autores más.
          </p>
        </div>

        <Button data-id="element-80">🧠 QUIERO DESARROLLAR MI MENTALIDAD</Button>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-16 px-4 bg-[#111] border-y border-gold/20 relative overflow-hidden" data-id="element-81">
        {/* Background glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-64 bg-gold/10 blur-[100px] rounded-full pointer-events-none" data-id="element-82"></div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-83">
          <div className="text-center mb-12" data-id="element-84">
            <h2 className="font-oswald text-3xl sm:text-4xl md:text-5xl font-bold mb-4 uppercase" data-id="element-85">
              Además recibirás <span className="text-gold" data-id="element-86">GRATIS</span> estos 5
              bonos exclusivos
            </h2>
            <div className="inline-flex items-center gap-2 bg-red-600 text-white px-6 py-2 rounded-full font-bold text-lg animate-pulse" data-id="element-87">
              <Clock className="w-5 h-5" data-id="element-88" />
              GRATIS SOLO POR HOY
            </div>
          </div>

          <div className="space-y-12 mb-12" data-id="element-89">
            {/* Bonus 1 */}
            <div className="group relative" data-id="element-90">
              <div className="absolute -inset-1 bg-gold rounded-xl blur opacity-10 group-hover:opacity-30 transition duration-500" data-id="element-91"></div>
              <a href="https://colorpack.store/cart/45917604184262:1" className="block relative bg-black rounded-xl border border-gold/30 overflow-hidden" data-id="element-92">
                <img src="https://cdn.magicpatterns.com/uploads/qWhqvdehBFJCyhDAA8AaZX/BON1.png" alt="Bono 1" className="w-full h-auto" data-id="element-93" />
                <div className="p-6 text-center border-t border-gold/10" data-id="element-94">
                  <h3 className="font-oswald text-2xl font-bold text-gold mb-2" data-id="element-95">
                    🎁 BONO #1: PLAN MAESTRO DE HÁBITOS DE ÉXITO
                  </h3>
                  <p className="text-gray-300" data-id="element-96">
                    Aprende a construir disciplina, eliminar malos hábitos y
                    mantener la constancia.
                  </p>
                </div>
              </a>
            </div>

            {/* Bonus 2 */}
            <div className="group relative" data-id="element-97">
              <div className="absolute -inset-1 bg-gold rounded-xl blur opacity-10 group-hover:opacity-30 transition duration-500" data-id="element-98"></div>
              <a href="https://colorpack.store/cart/45917604184262:1" className="block relative bg-black rounded-xl border border-gold/30 overflow-hidden" data-id="element-99">
                <img src="https://cdn.magicpatterns.com/uploads/uKcqMhSpyDDcCVYiYN5nRc/BON2.png" alt="Bono 2" className="w-full h-auto" data-id="element-100" />
                <div className="p-6 text-center border-t border-gold/10" data-id="element-101">
                  <h3 className="font-oswald text-2xl font-bold text-gold mb-2" data-id="element-102">
                    🎁 BONO #2: GUÍA PARA REPROGRAMAR TU MENTALIDAD
                  </h3>
                  <p className="text-gray-300" data-id="element-103">
                    Elimina creencias limitantes y desarrolla una mentalidad
                    ganadora.
                  </p>
                </div>
              </a>
            </div>

            {/* Bonus 3 */}
            <div className="group relative" data-id="element-104">
              <div className="absolute -inset-1 bg-gold rounded-xl blur opacity-10 group-hover:opacity-30 transition duration-500" data-id="element-105"></div>
              <a href="https://colorpack.store/cart/45917604184262:1" className="block relative bg-black rounded-xl border border-gold/30 overflow-hidden" data-id="element-106">
                <img src="https://cdn.magicpatterns.com/uploads/rfNKvi67hHbJAzhHM2h7bV/BON3.png" alt="Bono 3" className="w-full h-auto" data-id="element-107" />
                <div className="p-6 text-center border-t border-gold/10" data-id="element-108">
                  <h3 className="font-oswald text-2xl font-bold text-gold mb-2" data-id="element-109">
                    🎁 BONO #3: MANUAL DE FINANZAS PERSONALES E INTELIGENTES
                  </h3>
                  <p className="text-gray-300" data-id="element-110">
                    Organiza tu dinero y construye riqueza paso a paso.
                  </p>
                </div>
              </a>
            </div>

            {/* Bonus 4 */}
            <div className="group relative" data-id="element-111">
              <div className="absolute -inset-1 bg-gold rounded-xl blur opacity-10 group-hover:opacity-30 transition duration-500" data-id="element-112"></div>
              <a href="https://colorpack.store/cart/45917604184262:1" className="block relative bg-black rounded-xl border border-gold/30 overflow-hidden" data-id="element-113">
                <img src="https://cdn.magicpatterns.com/uploads/c4BmhLv85Bk4hn4ey6ZVYK/BON4.png" alt="Bono 4" className="w-full h-auto" data-id="element-114" />
                <div className="p-6 text-center border-t border-gold/10" data-id="element-115">
                  <h3 className="font-oswald text-2xl font-bold text-gold mb-2" data-id="element-116">
                    🎁 BONO #4: GUÍA DE PRODUCTIVIDAD EXTREMA
                  </h3>
                  <p className="text-gray-300" data-id="element-117">
                    Haz más en menos tiempo y elimina la procrastinación.
                  </p>
                </div>
              </a>
            </div>

            {/* Bonus 5 */}
            <div className="group relative" data-id="element-118">
              <div className="absolute -inset-1 bg-gold rounded-xl blur opacity-10 group-hover:opacity-30 transition duration-500" data-id="element-119"></div>
              <a href="https://colorpack.store/cart/45917604184262:1" className="block relative bg-black rounded-xl border border-gold/30 overflow-hidden" data-id="element-120">
                <img src="https://cdn.magicpatterns.com/uploads/dNmK6SbHN3jkyoDMnzjXc7/BON5.png" alt="Bono 5" className="w-full h-auto" data-id="element-121" />
                <div className="p-6 text-center border-t border-gold/10" data-id="element-122">
                  <h3 className="font-oswald text-2xl font-bold text-gold mb-2" data-id="element-123">
                    🎁 BONO #5: EL MAPA DE TU NUEVA VIDA
                  </h3>
                  <p className="text-gray-300" data-id="element-124">
                    Diseña tu visión, define tus metas y construye tu futuro.
                  </p>
                </div>
              </a>
            </div>
          </div>

          <Button data-id="element-125">🎁 QUIERO RECIBIR LOS 5 BONOS GRATIS</Button>
        </div>
      </section>

      {/* VISION / URGENCY SECTION */}
      <section className="py-16 px-4 max-w-3xl mx-auto text-center" data-id="element-126">
        <h2 className="font-oswald text-3xl sm:text-4xl font-bold mb-8" data-id="element-127">
          Imagina cómo será tu vida dentro de un año...
        </h2>

        <div className="bg-[#111] border border-gold/20 rounded-xl p-8 mb-10 text-left max-w-md mx-auto" data-id="element-128">
          <ul className="space-y-4 text-lg font-medium" data-id="element-129">
            <li className="flex items-center gap-3" data-id="element-130">
              <CheckCircle2 className="w-6 h-6 text-gold" data-id="element-131" /> ✔ Con mejores
              hábitos
            </li>
            <li className="flex items-center gap-3" data-id="element-132">
              <CheckCircle2 className="w-6 h-6 text-gold" data-id="element-133" /> ✔ Con más
              disciplina
            </li>
            <li className="flex items-center gap-3" data-id="element-134">
              <CheckCircle2 className="w-6 h-6 text-gold" data-id="element-135" /> ✔ Con una
              mentalidad más fuerte
            </li>
            <li className="flex items-center gap-3" data-id="element-136">
              <CheckCircle2 className="w-6 h-6 text-gold" data-id="element-137" /> ✔ Con más
              conocimientos
            </li>
            <li className="flex items-center gap-3" data-id="element-138">
              <CheckCircle2 className="w-6 h-6 text-gold" data-id="element-139" /> ✔ Con nuevas
              habilidades
            </li>
            <li className="flex items-center gap-3" data-id="element-140">
              <CheckCircle2 className="w-6 h-6 text-gold" data-id="element-141" /> ✔ Con mejores
              resultados
            </li>
          </ul>
        </div>

        <p className="text-xl text-gray-300 mb-4" data-id="element-142">
          La pregunta no es si este conocimiento funciona.
        </p>
        <p className="text-2xl font-bold text-white mb-8" data-id="element-143">La pregunta es:</p>
        <p className="font-oswald text-3xl sm:text-4xl text-gold mb-10" data-id="element-144">
          ¿Vas a aprovecharlo o seguir postergándolo?
        </p>

        <Button data-id="element-145">🔥 QUIERO CAMBIAR MI FUTURO DESDE HOY</Button>
      </section>

      {/* PRICE / OFFER SECTION */}
      <section className="py-16 px-4 bg-[#111] border-y border-gold/20" data-id="element-146">
        <div className="max-w-4xl mx-auto" data-id="element-147">
          <div className="bg-black border-2 border-gold rounded-2xl p-6 sm:p-10 relative shadow-gold-lg" data-id="element-148">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-red-600 text-white px-6 py-1 rounded-full font-bold text-sm sm:text-base uppercase tracking-wider whitespace-nowrap" data-id="element-149">
              OFERTA POR TIEMPO LIMITADO
            </div>

            <CountdownTimer data-id="element-150" />

            <h2 className="font-oswald text-3xl sm:text-4xl font-bold text-center mb-8" data-id="element-151">
              ¿Cuánto vale todo esto?
            </h2>

            <div className="max-w-md mx-auto space-y-3 text-lg text-gray-300 mb-8 font-mono" data-id="element-152">
              <div className="flex justify-between border-b border-white/10 pb-2" data-id="element-153">
                <span data-id="element-154">📚 30.000 Libros</span>
                <span data-id="element-155">$3.000+</span>
              </div>
              <div className="flex justify-between border-b border-white/10 pb-2" data-id="element-156">
                <span data-id="element-157">🎧 1.500 Audiolibros</span>
                <span data-id="element-158">$500+</span>
              </div>
              <div className="flex justify-between border-b border-white/10 pb-2" data-id="element-159">
                <span data-id="element-160">🎓 100 Cursos</span>
                <span data-id="element-161">$1.000+</span>
              </div>
              <div className="flex justify-between border-b border-white/10 pb-2" data-id="element-162">
                <span data-id="element-163">🎁 5 Bonos Exclusivos</span>
                <span data-id="element-164">$250+</span>
              </div>
              <div className="flex justify-between pt-4 text-xl text-white font-bold" data-id="element-165">
                <span data-id="element-166">Valor total estimado:</span>
                <span className="line-through text-red-500" data-id="element-167">$4.750 USD</span>
              </div>
            </div>

            <div className="text-center mb-8" data-id="element-168">
              <p className="text-xl text-gray-300 mb-4" data-id="element-169">
                Pero hoy no pagarás nada parecido a eso.
              </p>
              <h3 className="font-oswald text-2xl text-gold mb-2" data-id="element-170">
                OFERTA ESPECIAL
              </h3>
              <p className="text-lg mb-4" data-id="element-171">
                Acceso completo a LA BIBLIOTECA DEL ÉXITO™
              </p>
              <p className="text-gray-400 mb-2" data-id="element-172">Por solo</p>
              <div className="font-oswald text-6xl sm:text-8xl font-bold text-white mb-8 drop-shadow-[0_0_15px_rgba(212,175,55,0.5)]" data-id="element-173">
                $8.99{' '}
                <span className="text-3xl sm:text-4xl text-gray-400" data-id="element-174">USD</span>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-lg mx-auto mb-10 text-sm sm:text-base" data-id="element-175">
              <div className="flex items-center gap-2" data-id="element-176">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-177" /> ✅ Pago
                único
              </div>
              <div className="flex items-center gap-2" data-id="element-178">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-179" /> ✅ Acceso
                inmediato
              </div>
              <div className="flex items-center gap-2" data-id="element-180">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-181" /> ✅ Sin
                mensualidades
              </div>
              <div className="flex items-center gap-2" data-id="element-182">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-183" /> ✅ Acceso de
                por vida
              </div>
              <div className="flex items-center gap-2 sm:col-span-2 sm:justify-center" data-id="element-184">
                <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-185" /> ✅
                Actualizaciones futuras
              </div>
            </div>

            <Button className="text-xl sm:text-2xl py-6" data-id="element-186">
              🚀 SÍ, QUIERO ACCEDER A LA BIBLIOTECA DEL ÉXITO
            </Button>

            <div className="flex items-center justify-center gap-2 mt-6 text-gray-400 text-sm" data-id="element-187">
              <ShieldCheck className="w-5 h-5" data-id="element-188" />
              <span data-id="element-189">Pago 100% Seguro y Encriptado</span>
            </div>
          </div>
        </div>
      </section>

      {/* WHY DIFFERENT SECTION */}
      <section className="py-16 px-4 max-w-4xl mx-auto" data-id="element-190">
        <h2 className="font-oswald text-3xl sm:text-4xl font-bold text-center mb-12" data-id="element-191">
          ¿Por qué esta oferta es diferente?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-192">
          <div className="bg-red-900/10 border border-red-500/20 rounded-xl p-6" data-id="element-193">
            <h3 className="font-bold text-xl text-red-400 mb-4 text-center" data-id="element-194">
              Lo Tradicional
            </h3>
            <ul className="space-y-4" data-id="element-195">
              <li className="flex items-start gap-3 text-gray-300" data-id="element-196">
                <span className="text-red-500" data-id="element-197">❌</span> No pagas suscripciones
                mensuales
              </li>
              <li className="flex items-start gap-3 text-gray-300" data-id="element-198">
                <span className="text-red-500" data-id="element-199">❌</span> No dependes de
                aplicaciones externas
              </li>
              <li className="flex items-start gap-3 text-gray-300" data-id="element-200">
                <span className="text-red-500" data-id="element-201">❌</span> No hay límites de
                lectura
              </li>
              <li className="flex items-start gap-3 text-gray-300" data-id="element-202">
                <span className="text-red-500" data-id="element-203">❌</span> No perderás tu acceso
              </li>
            </ul>
          </div>

          <div className="bg-green-900/10 border border-green-500/20 rounded-xl p-6" data-id="element-204">
            <h3 className="font-bold text-xl text-green-400 mb-4 text-center" data-id="element-205">
              La Biblioteca del Éxito
            </h3>
            <ul className="space-y-4" data-id="element-206">
              <li className="flex items-start gap-3 text-white font-medium" data-id="element-207">
                <span className="text-green-500" data-id="element-208">✅</span> Todo es tuyo para
                siempre
              </li>
              <li className="flex items-start gap-3 text-white font-medium" data-id="element-209">
                <span className="text-green-500" data-id="element-210">✅</span> Disponible desde
                cualquier dispositivo
              </li>
              <li className="flex items-start gap-3 text-white font-medium" data-id="element-211">
                <span className="text-green-500" data-id="element-212">✅</span> Descarga cuando
                quieras
              </li>
              <li className="flex items-start gap-3 text-white font-medium" data-id="element-213">
                <span className="text-green-500" data-id="element-214">✅</span> Aprende a tu ritmo
              </li>
            </ul>
          </div>
        </div>

        <Button data-id="element-215">💎 QUIERO MI ACCESO DE POR VIDA</Button>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section className="py-16 px-4 bg-[#111] border-y border-gold/20" data-id="element-216">
        <div className="max-w-5xl mx-auto" data-id="element-217">
          <h2 className="font-oswald text-3xl sm:text-4xl font-bold text-center mb-12" data-id="element-218">
            Lo que dicen nuestros usuarios
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-219">
            {[{
            name: 'Roberto M.',
            role: 'Emprendedor',
            text: 'Encontré libros que llevaba años buscando. La sección de finanzas personales literalmente cambió mi forma de ver el dinero.',
            img: 'https://i.pravatar.cc/150?img=11'
          }, {
            name: 'Elena G.',
            role: 'Estudiante',
            text: 'El valor es muchísimo mayor de lo que pagué. Solo con los bonos ya recuperé la inversión. Lo recomiendo 100%.',
            img: 'https://i.pravatar.cc/150?img=5'
          }, {
            name: 'Carlos V.',
            role: 'Gerente de Ventas',
            text: 'Los audiolibros y cursos son increíbles. Escucho un audiolibro diferente cada día mientras voy al trabajo en mi auto.',
            img: 'https://i.pravatar.cc/150?img=15'
          }, {
            name: 'Mariana L.',
            role: 'Freelancer',
            text: 'Tengo una biblioteca completa en mi celular. La guía de productividad extrema me ayudó a organizar mi tiempo como nunca.',
            img: 'https://i.pravatar.cc/150?img=9'
          }, {
            name: 'Andrés F.',
            role: 'Inversor',
            text: 'No podía creer la cantidad de contenido por este precio. Es la mejor inversión en educación que he hecho este año.',
            img: 'https://i.pravatar.cc/150?img=12'
          }].map((t, i) => <div key={i} className="bg-[#0a0a0a] border border-white/10 rounded-xl p-6 flex flex-col h-full" data-id="element-220">
                <div className="flex text-gold mb-4" data-id="element-221">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-222" />)}
                </div>
                <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-223">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3 mt-auto" data-id="element-224">
                  <img src={t.img} alt={t.name} className="w-12 h-12 rounded-full border border-gold/30" data-id="element-225" />
                  <div data-id="element-226">
                    <p className="font-bold text-white" data-id="element-227">{t.name}</p>
                    <p className="text-sm text-gray-500" data-id="element-228">{t.role}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 px-4 max-w-3xl mx-auto" data-id="element-229">
        <h2 className="font-oswald text-3xl sm:text-4xl font-bold text-center mb-10" data-id="element-230">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-231">
          {[{
          q: '¿El acceso es inmediato?',
          a: 'Sí. Recibirás el acceso automáticamente en tu correo electrónico después de realizar tu compra.'
        }, {
          q: '¿Por cuánto tiempo tendré acceso?',
          a: 'Para toda la vida.'
        }, {
          q: '¿Puedo acceder desde mi celular?',
          a: 'Sí. Desde cualquier dispositivo (celular, tablet, computadora).'
        }, {
          q: '¿Puedo regalarlo?',
          a: 'Sí. Puedes compartirlo con quien desees.'
        }, {
          q: '¿Hay pagos mensuales?',
          a: 'No. Solo realizas un pago único de $8.99 USD.'
        }].map((faq, i) => <div key={i} className="bg-[#111] border border-white/10 rounded-lg p-6" data-id="element-232">
              <h3 className="font-bold text-lg text-gold mb-2 flex items-start gap-2" data-id="element-233">
                <Zap className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-234" />
                {faq.q}
              </h3>
              <p className="text-gray-300 ml-7" data-id="element-235">{faq.a}</p>
            </div>)}
        </div>
      </section>

      {/* FINAL CTA SECTION */}
      <section className="py-16 px-4 text-center border-t border-gold/20 bg-gradient-to-b from-[#0a0a0a] to-[#111]" data-id="element-236">
        <div className="max-w-3xl mx-auto" data-id="element-237">
          <p className="font-oswald text-2xl sm:text-3xl text-gold mb-6" data-id="element-238">
            Tu transformación comienza con una decisión.
          </p>
          <p className="text-xl text-gray-300 mb-2" data-id="element-239">
            Miles de personas pasan años buscando respuestas.
          </p>
          <p className="text-xl text-white font-bold mb-10" data-id="element-240">
            Tú puedes tenerlas hoy mismo en un solo lugar.
          </p>

          <h2 className="font-oswald text-4xl sm:text-5xl font-bold text-white mb-4" data-id="element-241">
            LA BIBLIOTECA DEL ÉXITO™
          </h2>
          <p className="text-lg sm:text-xl text-gray-400 mb-4" data-id="element-242">
            30.000 Libros + 1.500 Audiolibros + 100 Cursos + 5 Bonos
          </p>
          <p className="font-oswald text-4xl text-gold mb-10" data-id="element-243">SOLO $8.99 USD</p>

          <Button className="mb-8" data-id="element-244">🚀 QUIERO TRANSFORMAR MI VIDA HOY</Button>

          <div className="flex justify-center gap-4 text-gray-500 text-sm" data-id="element-245">
            <span data-id="element-246">© 2024 La Biblioteca del Éxito</span>
            <span data-id="element-247">•</span>
            <a href="#" className="hover:text-white" data-id="element-248">
              Términos
            </a>
            <span data-id="element-249">•</span>
            <a href="#" className="hover:text-white" data-id="element-250">
              Privacidad
            </a>
          </div>
        </div>
      </section>

      {/* STICKY BOTTOM BUTTON (Mobile only) */}
      <div className="fixed bottom-0 left-0 w-full p-4 bg-[#0a0a0a]/90 backdrop-blur-md border-t border-gold/20 z-40 sm:hidden" data-id="element-251">
        <a href="https://colorpack.store/cart/45917604184262:1" className="flex items-center justify-center w-full py-3 rounded-lg bg-gold-gradient text-black font-bold uppercase tracking-wide animate-pulse-scale" data-id="element-252">
          🚀 ACCEDER AHORA - $8.99
        </a>
      </div>
    </div>;
}